<!-- 蛋叔 V2 详情附件选择（条数多时可折叠，减轻规格弹窗纵向滚动） -->
<template>
  <div class="charge-selector" v-if="rows.length">
    <div
      v-for="(row, idx) in visibleRows"
      :key="row.chargeId || idx"
      class="charge-row"
      :class="{ 'charge-row-selected': Number(row.quantity) > 0 }">
      <div class="charge-meta">
        <div class="charge-name">{{ row.chargeName || "附件" }}</div>
        <div
          class="charge-price"
          v-if="row.isShowPrice !== false && row.chargePrice != null && row.chargePrice !== ''">
          {{ formatPrice(row.chargePrice) }}{{ row.cardPointTypeUnit || '点' }}
        </div>
      </div>
      <div class="charge-stepper">
        <van-stepper v-model="row.quantity" integer :min="0" :max="99" @change="emitChange" />
      </div>
    </div>
    <div
      v-if="showExpandMore"
      class="charge-expand-toggle"
      role="button"
      tabindex="0"
      @click="chargeExpanded = true"
      @keyup.enter="chargeExpanded = true"
    >
      展开更多（共 {{ rows.length }} 项）
    </div>
    <div
      v-else-if="showCollapse"
      class="charge-expand-toggle charge-expand-toggle--collapse"
      role="button"
      tabindex="0"
      @click="chargeExpanded = false"
      @keyup.enter="chargeExpanded = false"
    >
      收起
    </div>
  </div>
</template>

<script>
/** 默认折叠时最多展示的附件行数 */
const CHARGE_PREVIEW_MAX = 2;

export default {
  name: "ChargeSelector",
  props: {
    chargeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rows: [],
      chargeExpanded: false,
    };
  },
  computed: {
    visibleRows() {
      if (!this.rows.length) return [];
      if (this.chargeExpanded || this.rows.length <= CHARGE_PREVIEW_MAX) {
        return this.rows;
      }
      return this.rows.slice(0, CHARGE_PREVIEW_MAX);
    },
    showExpandMore() {
      return this.rows.length > CHARGE_PREVIEW_MAX && !this.chargeExpanded;
    },
    showCollapse() {
      return this.rows.length > CHARGE_PREVIEW_MAX && this.chargeExpanded;
    },
  },
  watch: {
    chargeList: {
      immediate: true,
      deep: true,
      handler(list) {
        this.chargeExpanded = false;
        this.rows = (list || []).map(c => ({
          chargeId: c.chargeId,
          chargeName: c.chargeName,
          chargePrice: c.chargePrice,
          chargeType: c.chargeType,
          cardPointTypeUnit: c.cardPointTypeUnit,
          isShowPrice: c.isShowPrice,
          quantity: 0,
        }));
        this.emitChange();
      },
    },
  },
  methods: {
    formatPrice(p) {
      const n = Number(p);
      if (isNaN(n)) return "--";
      return n.toFixed(2).replace(/\.?0+$/, "");
    },
    emitChange() {
      const selected = this.rows
        .filter(r => r.quantity > 0)
        .map(r => ({
          chargeId: r.chargeId,
          quantity: r.quantity,
          price: r.chargePrice,
        }));
      this.$emit("change", { selected });
    },
  },
};
</script>

<style scoped lang="scss">
.charge-selector {
  background: #fff;
  margin: 2px 0 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .charge-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    border: 1px solid #f2f3f5;
    border-radius: 6px;
    background: #fafbfc;
    transition: background-color 0.18s ease, border-color 0.18s ease;

    .charge-meta {
      flex: 1;
      min-width: 0;
      padding-right: 10px;
    }

    .charge-name {
      font-size: 12px;
      color: #333;
      line-height: 1.35;
    }

    .charge-price {
      font-size: 11px;
      color: #e44;
      margin-top: 2px;
      line-height: 1.3;
    }

    .charge-stepper {
      flex-shrink: 0;
      transform: scale(0.92);
      transform-origin: right center;
    }
  }

  .charge-row-selected {
    border-color: #ffd7bf;
    background: #fff7f2;
  }
}

.charge-expand-toggle {
  text-align: center;
  font-size: 12px;
  color: #1989fa;
  padding: 4px 0 2px;
  line-height: 1.4;
  user-select: none;
  cursor: pointer;
}

.charge-expand-toggle--collapse {
  color: #969799;
}
</style>
